import { Box, Text } from '@chakra-ui/react';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import useDeviceSize from '@/hooks/useDeviceSize';

import ChunkContainer from './ChunkContainer';
import Title from './Title';
import { MeetingStatsViewContext } from '../context/MeetingStatsViewContext';
import { PADDING_X_DESKTOP, PADDING_X_MOBILE } from '../utils/constants';

export const ParticipantChunk = () => {
  const { t } = useTranslation();
  const { isDesktopOrLaptop } = useDeviceSize();

  const { answerList, maxAmtParticipants } = useContext(MeetingStatsViewContext);

  const lines = useMemo(() => {
    const totalQuestionsAsked = answerList.reduce((acc, curr) => {
      acc.add(curr.slideId);
      return acc;
    }, new Set<string>());
    const numberOfUniqueVotes = answerList.reduce((acc, curr) => {
      acc.add(`${curr.slideId}-${curr.userId}`);
      return acc;
    }, new Set<string>());

    return [
      {
        title: 'Number of participants:',
        value: maxAmtParticipants,
      },
      {
        title: 'Number of votes:',
        value: numberOfUniqueVotes.size,
      },
      {
        title: 'Number of questions asked:',
        value: totalQuestionsAsked.size,
      },
    ];
  }, [answerList, maxAmtParticipants]);

  return (
    <ChunkContainer>
      <Title text={t('meetings.stats.participants.title')} />
      <Box
        marginY="10px"
        marginBottom="15px"
        width="100%"
        paddingX={isDesktopOrLaptop ? PADDING_X_DESKTOP : PADDING_X_MOBILE}
      >
        {lines.map((line, idx) => (
          <Box
            key={line.title + idx}
            display="flex"
            flexDir="row"
            paddingTop="5px"
            paddingBottom="5px"
            alignItems="center"
            marginBottom="10px"
            gap={2}
          >
            <Text variant="graySubTitle" noOfLines={1} flexShrink={9999} wordBreak="break-all">
              {line.title}
            </Text>
            <Text fontSize="17px" fontFamily="nunito-bold" color="livelinx.purple200" noOfLines={1}>
              {line.value}
            </Text>
          </Box>
        ))}
      </Box>
    </ChunkContainer>
  );
};
